module.exports = __webpack_public_path__ + "img/logo.a5c36abe.png";